export default "__VITE_ASSET__b86ed963__"